// extracted by mini-css-extract-plugin
export default {"summary":"MkczX","container":"rBNyA","info":"L8xej","title":"_88Ejh","expandButton":"IYLDv","tickets":"CGhfX","expanded":"P1fdj"};